// HeaderStyles.js
import styled from 'styled-components';

export const StyledHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px; /* Altura fija para el header */
  padding: 10px 20px;
  background-color: #0078d4; /* Cambiado a un color más destacado */
  color: white;
  border-bottom: 1px solid #ddd;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* Añade una sombra sutil */
`;

export const UserName = styled.div`
  font-size: 18px;
`;

export const LogoImg = styled.img`
  height: 50px; /* Ajusta según el tamaño deseado */
  width: auto;
`;

export const LogoutButton = styled.button`
  padding: 8px 16px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
  background-color: #005a9e;
  color: #fff;
  outline: none;
  transition: background-color 0.3s;

  &:hover {
    background-color: #004080; 
  }
`;


